

export const extractTwitterId = (url: string): string => {
    if (!url) return ""
    const pattern = /(?:https?:\/\/)?(?:www\.)?(?:twitter\.com|x\.com)\/(?:#!\/)?(?:\w+)\/status(?:es)?\/(\d+)/
    const match = url.match(pattern)
    return match ? match[1] : ""
}


export const getTwitterCanonicalUrl = (urlOrId: string): string => {
    const tweetId = urlOrId.match(/^\d+$/) ? urlOrId : extractTwitterId(urlOrId)
    if (!tweetId) return ""
    return `https://twitter.com/i/status/${tweetId}`
}